/**
 * Debounces a function
 *
 * @param {Function} func     The function to debounce
 * @param {Integer}  interval The interval, in milliseconds
 * @return {Function}         The function debounced
 */
const debounce = ( func, interval ) => {
	let lastCall = -1;

	return () => {
		clearTimeout( lastCall );
		// eslint-disable-next-line no-undef
		const args = arguments;
		const self = this;
		lastCall = setTimeout( () => {
			func.apply( self, args );
		}, interval );
	};
};

export default debounce;
